export const API_BANK_NAME_TO_DISPLAY_NAME_MAP = {
  "Michigan State University Federal Credit Union": "MSUFCU",
};

export const ICON_WRAPPER_WIDTH = 40;
